import { downloadLinkId } from '@lib/enums/selectors';

export default function downloadHandler(downloadLink?: string) {
  try {
    if (downloadLink) {
      const link = document.getElementById(downloadLinkId);
      if (downloadLink && link) {
        link.setAttribute('href', downloadLink);
        link.click();
        link.setAttribute('href', '');
      }
    }
  } catch (error) {
    console.warn(error);
  }
}
